// Typelizer digest b4d161b7cd4574a34f215ff45fac3cc5
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /login/code */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/login/code', {}, options),
    method: 'post',
  }),
}
